import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsWiseCompanyService {
  constructor(private http: HttpClient) {}
  departmentsOnChange = new BehaviorSubject([]);

  getDepartmentsForOptions(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/department-wise-companies/get`)
        .subscribe({
          next: (response: any) => {
            this.departmentsOnChange.next(response);
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
